export const DONATION_STATUS_FILTERS = [
  {
    id: "",
    translationKey: "dashboard.select_filter_please_select_status",
    fallback: "All Donation Statuses",
  },
  {
    id: "successful",
    translationKey: "dashboard.select_filter_successful",
    fallback: "Successful",
  },
  {
    id: "authorized",
    translationKey: "dashboard.select_filter_authorized",
    fallback: "Authorized",
  },
  {
    id: "processed",
    translationKey: "dashboard.select_filter_processed",
    fallback: "Processed",
  },
  {
    id: "pending",
    translationKey: "dashboard.select_filter_pending",
    fallback: "Pending",
  },
  {
    id: "failed",
    translationKey: "dashboard.select_filter_failed",
    fallback: "Failed",
  },
  {
    id: "canceled",
    translationKey: "dashboard.select_filter_canceled",
    fallback: "Canceled",
  },
  {
    id: "unpublished",
    translationKey: "dashboard.select_filter_unpublished",
    fallback: "Unpublished",
  },
  {
    id: "recurring",
    translationKey: "dashboard.select_filter_recurring",
    fallback: "Recurring",
  },
];

export const KNOWN_DONATION_STATUS_FILTER_IDS = DONATION_STATUS_FILTERS.map(({ id }) => id);

export const sanitizeDonationStatusFilter = (value) => {
  if (value === undefined || value === null) {
    return "";
  }

  const normalized = String(value).toLowerCase();

  return KNOWN_DONATION_STATUS_FILTER_IDS.includes(normalized) ? normalized : "";
};
